<app-navigation
    [automaticFooterPadding]="false"
    [automaticNavbarPadding]="false"
    [additionalContainerClasses]="[]">
    <app-knowledge-article-detail
        [urlSlug]="urlSlug"></app-knowledge-article-detail>
</app-navigation>
